"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOURCES_ID_PREFIX = exports.SCENE_ITEM_ID_PREFIX = exports.LAYER_SOURCE_ITEM_ID_PREFIX = exports.BANNER_LAYER_SOURCE_ITEM_ID_PREFIX = void 0;
var SCENE_ITEM_ID_PREFIX = exports.SCENE_ITEM_ID_PREFIX = 'scene-manager-item-';
var BANNER_LAYER_SOURCE_ITEM_ID_PREFIX = exports.BANNER_LAYER_SOURCE_ITEM_ID_PREFIX = 'banner-layer-source-manager-item-';
var LAYER_SOURCE_ITEM_ID_PREFIX = exports.LAYER_SOURCE_ITEM_ID_PREFIX = 'layer-source-manager-item-';
var SOURCES_ID_PREFIX = exports.SOURCES_ID_PREFIX = 'source-item-prefix-';